(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hw-shipping-estimate-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('hw__se_modal');
    if (!modal || modal.dataset.hwSeInit === 'true') {
      return;
    }
    modal.dataset.hwSeInit = 'true';

    var ANCHOR = modal.getAttribute('data-anchor') || 'hw-shipping-estimates';
    // Locale-aware base for Ajax API calls; always ends in "/".
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var MAX_POLL_ATTEMPTS = 20;
    var POLL_INTERVAL_MS = 500;
    // Private line item property (leading underscore) marking our temporary line.
    var SAMPLE_PROPERTY = '_hw_shipping_estimate';
    var form = modal.querySelector('[data-hw-se-form]');
    var results = modal.querySelector('[data-hw-se-results]');
    var submit = modal.querySelector('[data-hw-se-submit]');
    var spinner = modal.querySelector('.hw__se-spinner');
    var countrySelect = modal.querySelector('[data-hw-se-country]');
    var provinceField = modal.querySelector('[data-hw-se-province-field]');
    var provinceSelect = modal.querySelector('[data-hw-se-province]');
    var zipInput = modal.querySelector('#hw__se_zip');

    var showCountry = modal.getAttribute('data-show-country') === 'true';
    var showProvince = modal.getAttribute('data-show-province') === 'true';
    var defaultCountry = modal.getAttribute('data-country') || '';
    var sampleVariant = modal.getAttribute('data-sample-variant') || '';
    var currency = modal.getAttribute('data-currency') || '';
    var locale = modal.getAttribute('data-locale') || 'en';
    var errorText = modal.getAttribute('data-error-text') || '';
    var noRatesText = modal.getAttribute('data-no-rates-text') || '';
    var noSampleText = modal.getAttribute('data-no-sample-text') || '';
    var resultsHeading = modal.getAttribute('data-results-heading') || '';
    var freeText = modal.getAttribute('data-free-text') || 'Free';
    var showDescription = modal.getAttribute('data-show-description') === 'true';

    var lastFocused = null;
    // Hidden iframe supplying an unpatched fetch for the estimate cart calls.
    var cleanFrame = null;

    function isOpen() {
      return modal.hasAttribute('open');
    }

    function formatMoney(value) {
      var amount = parseFloat(value);
      if (isNaN(amount)) {
        return value;
      }
      if (amount === 0) {
        return freeText;
      }
      if (currency && typeof Intl !== 'undefined' && Intl.NumberFormat) {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
        } catch (e) {
          /* fall through to plain formatting */
        }
      }
      return amount.toFixed(2);
    }

    function openModal() {
      if (isOpen()) {
        return;
      }
      lastFocused = document.activeElement;
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
      var focusTarget = showCountry ? countrySelect : zipInput;
      if (focusTarget) {
        focusTarget.focus();
      }
    }

    function closeModal() {
      if (!isOpen()) {
        return;
      }
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
        onClosed();
      }
    }

    function onClosed() {
      document.documentElement.style.overflow = '';
      if (location.hash === '#' + ANCHOR) {
        history.replaceState(null, '', location.pathname + location.search);
      }
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function setLoading(isLoading) {
      if (submit) {
        submit.disabled = isLoading;
      }
      if (spinner) {
        if (isLoading) {
          spinner.removeAttribute('hidden');
        } else {
          spinner.setAttribute('hidden', '');
        }
      }
    }

    function renderMessage(text, isError) {
      results.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'hw__se-results__message' + (isError ? ' hw__se-results__message--error' : '');
      p.textContent = text;
      results.appendChild(p);
    }

    function renderRates(rates) {
      results.innerHTML = '';
      if (!rates || !rates.length) {
        renderMessage(noRatesText, false);
        return;
      }
      var heading = document.createElement('p');
      heading.className = 'hw__se-results__message';
      heading.textContent = resultsHeading;
      results.appendChild(heading);

      var list = document.createElement('ul');
      list.className = 'hw__se-rates';
      rates.forEach(function (rate) {
        var item = document.createElement('li');
        item.className = 'hw__se-rates__item';

        var name = document.createElement('span');
        name.className = 'hw__se-rates__name';

        var title = document.createElement('span');
        title.className = 'hw__se-rates__title';
        title.textContent = rate.presentment_name || rate.name;
        name.appendChild(title);

        if (showDescription && rate.description) {
          var description = document.createElement('span');
          description.className = 'hw__se-rates__description';
          description.textContent = rate.description;
          name.appendChild(description);
        }

        var price = document.createElement('span');
        price.className = 'hw__se-rates__price';
        price.textContent = formatMoney(rate.price);

        item.appendChild(name);
        item.appendChild(price);
        list.appendChild(item);
      });
      results.appendChild(list);
    }

    function buildAddressQuery(address) {
      var params = [];
      Object.keys(address).forEach(function (key) {
        if (address[key]) {
          params.push('shipping_address[' + key + ']=' + encodeURIComponent(address[key]));
        }
      });
      return params.join('&');
    }

    function delay(ms) {
      return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    function pollRates(cleanFetch, query, attempt) {
      attempt = attempt || 0;
      return cleanFetch(ROOT + 'cart/async_shipping_rates.json?' + query, {
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('rates_error');
        }
        return response.json();
      }).then(function (data) {
        if (data === null || data.shipping_rates === undefined) {
          if (attempt >= MAX_POLL_ATTEMPTS) {
            throw new Error('timeout');
          }
          return delay(POLL_INTERVAL_MS).then(function () {
            return pollRates(cleanFetch, query, attempt + 1);
          });
        }
        return data.shipping_rates;
      });
    }

    function fetchRates(cleanFetch, query) {
      return cleanFetch(ROOT + 'cart/prepare_shipping_rates.json?' + query, {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('prepare_error');
        }
        return pollRates(cleanFetch, query);
      });
    }

    /*
     * Third-party scripts on this store (the cart drawer, Rebuy, Klaviyo and
     * Shopify Web Pixels) monkey-patch window.fetch so they can spot calls to
     * /cart/add.js and /cart/change.js and emit add_to_cart events. The line we
     * add here is synthetic — added and removed within the same estimate purely
     * to read a shipping rate — so it must not be observed. fetch patches are
     * per-realm, so a same-origin about:blank iframe gives us an untouched copy
     * of fetch. Every estimate call goes through it, including the rate calls,
     * so nothing about this flow is visible to those patches. This is
     * deliberate: don't "fix" these calls back to window.fetch, and don't reuse
     * this fetch for genuine cart interactions, which must still fire their
     * events.
     */
    function getCleanFetch() {
      if (cleanFrame && cleanFrame.contentWindow && typeof cleanFrame.contentWindow.fetch === 'function') {
        return cleanFrame.contentWindow.fetch.bind(cleanFrame.contentWindow);
      }

      destroyCleanFrame();

      var frame = document.createElement('iframe');
      frame.src = 'about:blank';
      frame.style.display = 'none';
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      // contentWindow only exists once the element is in the document.
      document.body.appendChild(frame);

      var frameWindow = frame.contentWindow;
      if (!frameWindow || typeof frameWindow.fetch !== 'function') {
        if (frame.parentNode) {
          frame.parentNode.removeChild(frame);
        }
        // No fallback to window.fetch: a phantom add_to_cart event is worse
        // than showing no estimate at all.
        return null;
      }

      cleanFrame = frame;
      return frameWindow.fetch.bind(frameWindow);
    }

    function destroyCleanFrame() {
      if (cleanFrame && cleanFrame.parentNode) {
        cleanFrame.parentNode.removeChild(cleanFrame);
      }
      cleanFrame = null;
    }

    function changeCartItem(cleanFetch, id, quantity) {
      return cleanFetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity })
      });
    }

    // The private property (leading underscore, so it's hidden from the cart and
    // checkout) keeps this line separate from any line the shopper adds for the
    // same variant, so removing it can never touch their own item.
    // Rejects with 'sample_unavailable' when the sample can't be added (e.g. it
    // sold out since the page was rendered) so the caller can say so rather
    // than failing silently.
    function addSampleItem(cleanFetch) {
      var properties = {};
      properties[SAMPLE_PROPERTY] = '1';

      return cleanFetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: sampleVariant, quantity: 1, properties: properties })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('sample_unavailable');
        }
        return response.json();
      }).then(function (item) {
        // The line item key identifies the exact line we just created.
        var key = (item && item.key) || '';
        if (!key) {
          throw new Error('sample_unavailable');
        }
        return key;
      });
    }

    function removeSampleItem(cleanFetch, key) {
      if (!key) {
        return Promise.resolve();
      }
      return changeCartItem(cleanFetch, key, 0).catch(function () {
        /* leave the cart alone if the removal itself fails */
      });
    }

    function estimateWithSample(cleanFetch, query) {
      var sampleKey = '';
      return addSampleItem(cleanFetch)
        .then(function (key) {
          sampleKey = key;
          return fetchRates(cleanFetch, query);
        })
        .then(function (rates) {
          return removeSampleItem(cleanFetch, sampleKey).then(function () {
            return rates;
          });
        })
        .catch(function (error) {
          // Always attempt to restore the cart even if rating failed.
          return removeSampleItem(cleanFetch, sampleKey).then(function () {
            throw error;
          });
        });
    }

    function handleSubmit(event) {
      event.preventDefault();

      var address = {
        country: showCountry && countrySelect ? countrySelect.value : defaultCountry,
        province: showProvince && provinceSelect ? provinceSelect.value : '',
        zip: zipInput ? zipInput.value.trim() : ''
      };

      if (!address.zip) {
        renderMessage(errorText, true);
        return;
      }

      var query = buildAddressQuery(address);
      var cartIsEmpty = modal.getAttribute('data-cart-count') === '0';
      var needsSample = cartIsEmpty && sampleVariant;

      // No sample to rate against, so there is nothing to estimate.
      if (cartIsEmpty && !sampleVariant) {
        renderMessage(noSampleText, true);
        return;
      }

      var cleanFetch = getCleanFetch();
      if (!cleanFetch) {
        renderMessage(errorText, true);
        return;
      }

      setLoading(true);
      results.innerHTML = '';

      var run;
      if (needsSample) {
        run = estimateWithSample(cleanFetch, query);
      } else {
        run = fetchRates(cleanFetch, query);
      }

      run.then(function (rates) {
        renderRates(rates);
      }).catch(function (error) {
        var message = error && error.message === 'sample_unavailable' ? noSampleText : errorText;
        renderMessage(message, true);
      }).then(function () {
        destroyCleanFrame();
        setLoading(false);
      });
    }

    function loadProvinces() {
      if (!showProvince || !countrySelect || !provinceSelect || !provinceField) {
        return;
      }
      var selectedOption = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      if (selectedOption) {
        try {
          provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
        } catch (e) {
          provinces = [];
        }
      }
      provinceSelect.innerHTML = '';
      if (!provinces.length) {
        provinceField.style.display = 'none';
        return;
      }
      provinceField.style.display = '';
      provinces.forEach(function (province) {
        var option = document.createElement('option');
        option.value = province[0];
        option.textContent = province[1];
        provinceSelect.appendChild(option);
      });
    }

    // Set default country selection.
    if (showCountry && countrySelect && defaultCountry) {
      for (var i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value === defaultCountry) {
          countrySelect.selectedIndex = i;
          break;
        }
      }
    }

    if (showCountry && countrySelect) {
      countrySelect.addEventListener('change', loadProvinces);
    }
    loadProvinces();

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    modal.addEventListener('click', function (event) {
      // Clicks on the dialog element itself are backdrop clicks.
      if (event.target === modal || event.target.closest('[data-hw-se-close]')) {
        closeModal();
      }
    });

    // Fired by close() and by the browser's native Escape handling.
    modal.addEventListener('close', onClosed);

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href="#' + ANCHOR + '"], a[href$="#' + ANCHOR + '"]');
      if (trigger) {
        event.preventDefault();
        openModal();
      }
    });

    function checkHash() {
      if (location.hash === '#' + ANCHOR) {
        openModal();
      }
    }

    window.addEventListener('hashchange', checkHash);
    checkHash();
  })();
  } catch(e) { console.error(e); }
})();

})();
